export default {
  common: {
    login: 'ログイン',
    logout: 'ログアウト',
    submit: '送信',
    cancel: 'キャンセル',
    confirm: '確認',
    save: '保存',
  },
  login: {
    title: 'ログイン',
    email: 'メールアドレス',
    password: 'パスワード',
    remember: 'ログイン状態を保持',
    forgot: 'パスワードをお忘れですか？',
    error: 'メールアドレスまたはパスワードが無効です',
    subtitle: '自動量的取引システム',
    telegramLogin: 'Telegram でログイン',
  },
  nav: {
    dashboard: 'ダッシュボード',
    trading: '取引',
    settings: '設定',
    message: 'メッセージ'
  },
  dashboard: {
    title: 'ダッシュボード',
    totalAssets: '総資産',
    dailyPnL: '日次損益',
    activeStrategies: '稼働中の戦略',
    recentTrades: '最近の取引',
    running: '稼働中',
    paused: '停止中',
    timeAgo: '{time}分前'
  },
  trading: {
    title: '取引管理',
    strategyConfig: '戦略設定',
    positions: 'ポジション',
    selectPair: '取引ペア選択',
    pleaseSelect: '選択してください',
    strategyType: '戦略タイプ',
    conservative: '保守的',
    aggressive: '積極的',
    investAmount: '投資額',
    enterAmount: '金額を入力',
    startStrategy: '戦略開始',
    closePosition: '決済',
    conservativeStrategy: '保守的戦略',
    aggressiveStrategy: '積極的戦略',
    stopSchedule: '停止予約',
    fillRequired: '必須項目を入力してください',
    strategyStarted: '戦略を開始しました',
    closingPosition: '決済中...',
    investMultiplier: '投資倍率',
    estimatedAmount: '予想投資額: {min} ~ {max} USDT',
    positionAmount: 'ポジション額',
    profit: '利益',
    pair: {
      'BTC/USDT': 'ビットコイン/USDT',
      'ETH/USDT': 'イーサリアム/USDT',
      'BNB/USDT': 'バイナンスコイン/USDT',
      'SOL/USDT': 'ソラナ/USDT'
    },
  },
  settings: {
    title: '設定',
    language: '言語',
    selectLanguage: '言語を選択',
    apiSettings: 'API設定',
    apiKey: 'APIキー',
    enterApiKey: 'APIキーを入力',
    secretKey: 'シークレットキー',
    enterSecretKey: 'シークレットキーを入力',
    riskControl: 'リスク管理',
    maxTradeAmount: '最大取引額',
    stopLoss: '損切り',
    notifications: '通知設定',
    tradeNotification: '取引通知',
    riskAlert: 'リスクアラート',
    saved: '設定を保存しました',
    logoutTitle: 'ログアウト確認',
    logoutConfirm: 'ログアウトしてもよろしいですか？',
    membership: 'メンバーシップ',
    trial: 'トライアル',
    basic: 'ベーシック',
    pro: 'プロ',
    premium: 'プレミアム',
    daysRemaining: '残り {days} 日',
    startTrial: 'トライアル開始',
    trialStarted: 'トライアル開始しました',
    purchase: '購入',
    tradingPairs: '取引ペア数',
    validPeriod: '有効期間',
    oneMonth: '1ヶ月',
    unlimited: '無制限',
    paymentTitle: 'QRコード決済',
    scanToPay: 'USDT-TRC20でスキャンしてください',
  },
  message: {
    title: 'メッセージセンター',
    notifications: '通知',
    logs: 'ログ',
    success: '成功',
    warning: '警告',
    trade: '取引',
    system: 'システム',
    strategyStarted: '{pair} 戦略開始',
    profitTarget: '目標利益達成 {amount}',
    tradingLog: '{pair} {action} @ {price}',
    systemLog: 'システム{action}'
  },
  // ... 其他翻譯
} 